import { z } from "zod";
import * as themeScheme from "@ecp-redux/dto/themeSettings/themeSettings.schemes";

export const IBoxC0MyCompanyInfoMessagesScheme = z.object({
  dashboard_text: themeScheme.MessageScheme.default("Dashboard"),
  dashboard_redirect_url: themeScheme.UrlScheme.default(""),
  my_investments_text: themeScheme.MessageScheme.default("Moje inwestycje"),
  my_investments_redirect_url: themeScheme.UrlScheme.default(""),
  shopping_lists_text: themeScheme.MessageScheme.default("Listy zakupowe"),
  shopping_lists_redirect_url: themeScheme.UrlScheme.default(""),
  reports_text: themeScheme.MessageScheme.default("Raporty"),
  reports_redirect_url: themeScheme.UrlScheme.default(""),
  offers_text: themeScheme.MessageScheme.default("Oferty"),
  offers_redirect_url: themeScheme.UrlScheme.default(""),
  your_promotions_text: themeScheme.MessageScheme.default("Twoje promocje"),
  your_promotions_redirect_url: themeScheme.UrlScheme.default(""),
  returns_text: themeScheme.MessageScheme.default("Zwroty"),
  returns_redirect_url: themeScheme.UrlScheme.default(""),
  settlements_text: themeScheme.MessageScheme.default("Rozliczenia"),
  settlements_redirect_url: themeScheme.UrlScheme.default(""),
  complaints_text: themeScheme.MessageScheme.default("Reklamacje"),
  complaints_redirect_url: themeScheme.UrlScheme.default(""),
  documents_text: themeScheme.MessageScheme.default("Dokumenty"),
  documents_redirect_url: themeScheme.UrlScheme.default(""),
  payments_and_delivery_text: themeScheme.MessageScheme.default(
    "Zamówienia i dostawy"
  ),
  payments_and_delivery_redirect_url: themeScheme.UrlScheme.default(""),
  deposits_text: themeScheme.MessageScheme.default("Depozyty"),
  deposits_redirect_url: themeScheme.UrlScheme.default(""),
  company_details_text: themeScheme.MessageScheme.default("Dane firmy"),
  company_details_redirect_url: themeScheme.UrlScheme.default(""),
  employees_text: themeScheme.MessageScheme.default("Pracownicy"),
  employees_redirect_url: themeScheme.UrlScheme.default(""),
  contracts_text: themeScheme.MessageScheme.default("Umowy"),
  contracts_redirect_url: themeScheme.UrlScheme.default(""),
  terms_of_trade_text: themeScheme.MessageScheme.default("Warunki handlowe"),
  terms_of_trade_redirect_url: themeScheme.UrlScheme.default(""),
  my_profile_text: themeScheme.MessageScheme.default("Mój profil"),
  my_profile_redirect_url: themeScheme.UrlScheme.default(""),
  logout_text: themeScheme.MessageScheme.default("Wyloguj się"),
  logout_redirect_url: themeScheme.UrlScheme.default(""),
  no_credit_limit_text: themeScheme.MessageScheme.default(
    "Brak limitu kredytowego"
  ),
  apply_for_credit_limit_text: themeScheme.MessageScheme.default(
    "Złóż wniosek o limit kredytowy"
  ),
  apply_for_credit_limit_redirect_url: themeScheme.UrlScheme.default(""),
  you_are_client_text: themeScheme.MessageScheme.default("Jesteś klientem"),
  become_client_premium_text: themeScheme.MessageScheme.default(
    "Zostań klientem Premium"
  ),
  become_client_premium_redirect_url: themeScheme.UrlScheme.default(""),
  become_client_max_text: themeScheme.MessageScheme.default(
    "Zostań klientem Max"
  ),
  become_client_max_redirect_url: themeScheme.UrlScheme.default(""),
  waiting_for_application_to_be_verified_text:
    themeScheme.MessageScheme.default("Oczekuje na weryfikację wniosku"),
  your_available_credit_limit_text: themeScheme.MessageScheme.default(
    "Twój dostępny limit kredytowy"
  ),
  accessible_text: themeScheme.MessageScheme.default("Dostępne:"),
  from_text: themeScheme.MessageScheme.default("z"),
  clear_all_text: themeScheme.MessageScheme.default("Wyczyść wszystko"),
  expand_text: themeScheme.MessageScheme.default("Rozwiń"),
  notification_text: themeScheme.MessageScheme.default("Powiadomienie"),
  expired_payments_text: themeScheme.MessageScheme.default(
    "przeterminowane płatności"
  ),
  closest_payment_in_text: themeScheme.MessageScheme.default(
    "Najbliższa płatność za:"
  ),
  have_text: themeScheme.MessageScheme.default("Masz"),
  new_notifications_text:
    themeScheme.MessageScheme.default("nowe powiadomienia"),
  days_text: themeScheme.MessageScheme.default("dni"),
});

export const IBoxC0MyCompanyInfoSettingsScheme = z.object({
  tooltip_style:
    themeScheme.TooltipIdScheme.default("tooltip$$1").catch("tooltip$$1"),
  main_button_style:
    themeScheme.ButtonIdScheme.default("button$$1").catch("button$$1"),
  mobile_only_notifications_mode:
    themeScheme.SettingBooleanScheme.default("false").catch("false"),
});
